import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import styles from '../../../styles';
import { /*BackgroundStripes, */ Logo } from './';
import { ColumnBlock } from '../../layout/components';
import { SomeLinks, SomeLink } from '../../pages/components';

const StyledFooter = styled.footer`
  //background: ${styles.color.BLACK};
  //color: ${styles.color.STONE};
  background: rgba(226, 229, 227, .25);
  color: ${styles.color.CHARCOAL};
  box-sizing: border-box;
  display: flex;
  font-size: 1.25rem;
  ${styles.media.tablet`
    font-size: 1.75rem;
  `}
  ${styles.media.phone`
    font-size: 1.25rem;
  `}
  line-height: 2rem;
  padding: 2.8125rem ${props =>
    props.breakpoint !== 'phone' ? 1.875 : 2.5}rem;
  width: 100%;
  position: relative;
  flex-wrap: wrap;
`;

const FooterColumn = styled(ColumnBlock).attrs({
  columns: 1,
})`
  box-sizing: border-box;
  padding-right: ${props =>
    props.breakpoint === 'phone'
      ? 0
      : props => (props.breakpoint === 'tablet' ? 3.75 : 5.625)}rem;
  padding-left: ${props => (props.breakpoint !== 'phone' ? 3.75 : 0)}rem;
  margin-bottom: ${props => (props.breakpoint !== 'phone' ? 0 : 2)}rem;

  > header {
    height: 5.625rem;
    font-family: 'ApercuMono';
    text-transform: uppercase;
    font-size: 1rem;
    ${styles.media.tablet`
      font-size: 1.25rem;
    `}
    ${styles.media.phone`
      font-size: 1rem;
    `}
    color: ${styles.color.SLATE};

    h3 {
      padding: 1rem 0;
    }
  }

  dd {
    ${styles.media.tablet`
      overflow: hidden;
      text-overflow: ellipsis;
    `}
  }

  p,
  dd,
  address {
    margin-bottom: 1.5rem;
  }
  
  p a {
    font-size: 1.25rem;
    ${styles.media.tablet`
      font-size: 1.75rem;
    `}
    ${styles.media.phone`
      font-size: 1.25rem;
    `}
  }

  address {
    font-family: 'ApercuBold';
  }

  a,
  h4 {
    font-family: 'ApercuBold';
    color: ${styles.color.ORANGE};
  }
`;

const SectionsList = styled.ul`
  li {
    margin-bottom: 1.5rem;
  }
`;

const UnderlineLink = styled.a`
  position: relative;
  transition: color 0.25s ${styles.easing.inOutCubic};

  &:after {
    content: '';
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 2px;
    background: #ff7500;
    bottom: -2px;
    left: 0;
    transition: transform 0.25s ${styles.easing.inOutCubic};
    transform: scale(0, 1) translate3d(0, 0, 0);
    transform-origin: 100% 50%;
  }

  .current-input-mouse &:hover,
  .current-input-touch &:active {
    color: ${styles.color.CHARCOAL};
    &:after {
      transform-origin: 0% 50%;
      transform: scale(1, 1) translate3d(0, 0, 0);
    }
  }
`;

const UnderlineNavLink = UnderlineLink.withComponent(NavLink);

const AppFooter = props => {
  const { breakpoint } = props;
  return (
    <StyledFooter breakpoint={breakpoint}>
      {/* <BackgroundStripes color={'rgba(255, 255, 255, .15)'} /> */}
      <FooterColumn breakpoint={breakpoint}>
        <header>
          <Logo theme="footer" />
        </header>
        <p>Our studio is located in the heart of Soho London.</p>
        <address>
          Space Ape Games<br />
          100 New Oxford Street<br />
          London<br />
          WC1A 1HB
        </address>
        <p>
          <UnderlineLink
            href="https://www.google.co.uk/maps/place/Space+Ape+Games/@51.5167568,-0.1304442,17z/data=!4m5!3m4!1s0x0:0x4bd8259037b111b3!8m2!3d51.5166831!4d-0.1285445"
            target="_blank"
          >
            View on map
          </UnderlineLink>
        </p>
        <SectionsList>
          <li>
            <UnderlineNavLink to="/terms-conditions">
              Terms and Conditions
            </UnderlineNavLink>
          </li>
          <li>
            <UnderlineNavLink to="/privacy-policy">
              Privacy Policy
            </UnderlineNavLink>
          </li>
        </SectionsList>
      </FooterColumn>
      <FooterColumn breakpoint={breakpoint}>
        <header>
          <h3>Email Contacts</h3>
        </header>
        <dl>
          <dt>Press contact</dt>
          <dd>
            <UnderlineLink href="mailto:press@spaceapegames.com">
              press@spaceapegames.com
            </UnderlineLink>
          </dd>
          <dt>General enquiries</dt>
          <dd>
            <UnderlineLink href="mailto:info@spaceapegames.com">
              info@spaceapegames.com
            </UnderlineLink>
          </dd>
          <dt>Careers</dt>
          <dd>
            <UnderlineLink href="mailto:careers@spaceapegames.com">
              careers@spaceapegames.com
            </UnderlineLink>
          </dd>
          <dt>Support</dt>
          <dd>
            <UnderlineLink href="mailto:support@spaceapegames.com">
              support@spaceapegames.com
            </UnderlineLink>
          </dd>
        </dl>
      </FooterColumn>
      <FooterColumn breakpoint={breakpoint}>
        <header>
          <h3>Blogs</h3>
        </header>
        <dl>
          <dt>Insights</dt>
          <dd>
            <UnderlineLink href="http://weare-bananas.tumblr.com/">
              Inside the studio
            </UnderlineLink>
          </dd>
          <dt>Technology</dt>
          <dd>
            <UnderlineLink href="https://tech.spaceapegames.com/">
              The Ape Grid
            </UnderlineLink>
          </dd>
          <dt>User experience</dt>
          <dd>
            <UnderlineLink href="https://medium.com/the-space-ape-games-experience">
              UX Blog
            </UnderlineLink>
          </dd>
          <dt>Game art</dt>
          <dd>
            <UnderlineLink href="http://spaceapegamesart.tumblr.com">
              Art Team Blog
            </UnderlineLink>
          </dd>
          <dt>Live</dt>
          <dd>
            <UnderlineLink href="https://www.twitch.tv/spaceapegames">
              Space Ape Live!
            </UnderlineLink>
          </dd>
        </dl>
      </FooterColumn>
      <FooterColumn breakpoint={breakpoint}>
        <header>
          <h3>Site Sections</h3>
        </header>
        <SectionsList>
          <li>
            <UnderlineNavLink to="/">Home</UnderlineNavLink>
          </li>
          <li>
            <UnderlineNavLink to="/about">About the Studio</UnderlineNavLink>
          </li>
          <li>
            <UnderlineNavLink to="/games">Our Games</UnderlineNavLink>
          </li>
          <li>
            <UnderlineNavLink to="/careers">Careers</UnderlineNavLink>
          </li>
          <li>
            <UnderlineNavLink to="/news-events">News & Events</UnderlineNavLink>
          </li>
        </SectionsList>

        <SomeLinks>
          <SomeLink
            theme="plain"
            type="twitter"
            link="https://twitter.com/SpaceApeGames"
          />
          <SomeLink
            theme="plain"
            type="facebook"
            link="https://www.facebook.com/SpaceApeGames"
          />
          <SomeLink
            theme="plain"
            type="linkedin"
            link="https://www.linkedin.com/company/space-ape-games"
          />
        </SomeLinks>
      </FooterColumn>
    </StyledFooter>
  );
};

const mapStateToProps = state => {
  const { breakpoint } = state.layout;
  return {
    breakpoint,
  };
};

export default connect(mapStateToProps, null)(AppFooter);



// WEBPACK FOOTER //
// ./src/modules/core/components/AppFooter.js